var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contacts"},[_c('h1',{staticClass:"contacts__heading"},[_vm._v("Контакты")]),_c('PhoneInfo'),_c('EmailInfo'),_c('Site'),_c('AddressInfo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }